/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import keyBy from 'lodash/keyBy';
import {
    CAMPSITE_AVAILABILITY_DESELECTED_CARD,
    CAMPSITE_AVAILABILITY_SELECTED_CARD,
    CLEAR_GET_AVAILABLE_CAMPSITES_ERROR,
    CLEAR_V3_FLEXIBLE_SEARCH_PARAMS,
    FETCHING_CAMPSITES_START,
    FETCHING_V3_CAMPSITES_START,
    GET_AVAILABLE_CAMPGROUND_SITES,
    GET_AVAILABLE_CAMPSITES,
    GET_AVAILABLE_CAMPSITES_ERROR,
    GET_UNFILTERED_CAMPSITES_COUNT,
    GET_V3_AVAILABLE_CAMPSITES,
    GET_V3_AVAILABLE_CAMPSITES_ERROR,
    SET_V3_FLEXIBLE_SEARCH_PARAMS,
} from '../constants';
import { getCampsiteProperties, getCampsitesWithLocation } from '../utils/campsite_utils';

const INITIALSTATE = {
    results: {
        campground_id: '',
        campsites: [],
        campsiteProperties: {
            hasLTSSites: false,
            hasDayUseSites: false,
            hasGroupSites: false,
            hasStandardSites: false,
            hasOvernightCampsites: false,
            campsiteTypeSelected: null,
        },
        countCampsitesWithLocation: 0,
    },
    v3Results: {
        campground_id: '',
        campsites: [],
        campsiteProperties: {
            hasLTSSites: false,
            hasDayUseSites: false,
            hasGroupSites: false,
            hasStandardSites: false,
            hasOvernightCampsites: false,
            campsiteTypeSelected: null,
        },
        countCampsitesWithLocation: 0,
        flexibleSearchParams: null,
    },
    selectedCardId: null,
    campsitesByKeys: {},
    isLoading: false,
    v3IsLoading: false,
};

export default function availableCampsites(state = INITIALSTATE, action) {
    const st = { ...state };

    switch (action.type) {
        case GET_AVAILABLE_CAMPSITES:
            st.results = action.payload;
            st.results.campsiteProperties = getCampsiteProperties(
                action.payload.campsites
            );
            st.results.countCampsitesWithLocation = getCampsitesWithLocation(
                action.payload.campsites
            ).length;
            st.campsitesByKeys = keyBy(
                action.payload.campsites,
                (campsite) => campsite.campsite_id
            );
            st.isLoading = false;
            return st;

        case GET_AVAILABLE_CAMPSITES_ERROR:
            st.err = action.payload;
            st.isLoading = false;
            return st;

        case FETCHING_CAMPSITES_START:
            st.isLoading = true;
            return st;

        case CLEAR_GET_AVAILABLE_CAMPSITES_ERROR:
            delete st.err;
            return st;

        case GET_AVAILABLE_CAMPGROUND_SITES:
            st[action.payload.campground_id] = action.payload;
            return st;

        case CAMPSITE_AVAILABILITY_SELECTED_CARD:
            st.selectedCardId = action.payload;
            return st;

        case CAMPSITE_AVAILABILITY_DESELECTED_CARD:
            st.selectedCardId = null;
            return st;

        case GET_UNFILTERED_CAMPSITES_COUNT:
            st.unfilteredCount = action.payload.totalCount;
            return st;

        case GET_V3_AVAILABLE_CAMPSITES:
            st.v3Results = {
                ...action.payload,
                campsiteProperties: getCampsiteProperties(action.payload.campsites),
                countCampsitesWithLocation: getCampsitesWithLocation(
                    action.payload.campsites
                ).length,
                flexibleSearchParams: state.v3Results.flexibleSearchParams || null,
            };
            st.v3IsLoading = false;
            return st;

        case GET_V3_AVAILABLE_CAMPSITES_ERROR:
            st.v3Err = action.payload;
            st.v3IsLoading = false;
            return st;

        case FETCHING_V3_CAMPSITES_START:
            st.v3IsLoading = true;
            return st;

        case SET_V3_FLEXIBLE_SEARCH_PARAMS:
            st.v3Results = {
                ...st.v3Results,
                flexibleSearchParams: {
                    months: action.payload.months,
                    nights: action.payload.nights,
                    weekendsOnly: action.payload.weekendsOnly,
                },
            };
            return st;

        case CLEAR_V3_FLEXIBLE_SEARCH_PARAMS:
            st.v3Results = {
                ...st.v3Results,
                flexibleSearchParams: null,
            };
            return st;

        default:
            return st;
    }
}
